@if (this.contactDetail$ | async; as contactDetail) {
  <div
    class="tab-pane fade flex-even active show h-100"
    id="claims"
    role="tabpanel"
    aria-labelledby="claims-tab"
  >
    <div class="d-flex flex-column h-100">
      <div class="row mt-2">
        <div class="col-12 col-md">
          <app-generic-grid
            style="height: 300px"
            [data]="contactDetail.insuranceClaims"
            [tabViewName]="'insuranceClaims'"/>
        </div>
      </div>
    </div>
  </div>
}
